import React, { memo } from "react";
import { FormattedNumber } from "react-intl";
import { withEmptyCheck } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
const PercentCellFormatter = memo(({ value = 0 }) => {
  return /* @__PURE__ */ React.createElement(FormattedNumber, { value: value / 100, style: "percent" });
});
const PercentCell = withEmptyCheck((props) => {
  return /* @__PURE__ */ React.createElement(PercentCellFormatter, { ...props });
});
function renderPercentCell(params) {
  const value = params?.value;
  return /* @__PURE__ */ React.createElement(PercentCell, { value: value?.value });
}
export {
  PercentCell,
  PercentCellFormatter,
  renderPercentCell
};
//# sourceMappingURL=PercentCell.js.map
